var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2383 7.7109C11.4725 7.26053 10.6828 6.85132 9.87504 6.48233C10.2004 5.70372 10.4899 4.91121 10.7312 4.1C11.0282 3.10286 11.287 1.50659 10.2343 0.873211C8.99552 0.127693 8.22486 1.76362 7.69796 2.67799C7.22863 3.491 6.80376 4.33024 6.41728 5.18682C5.16381 4.81564 3.88181 4.53834 2.58405 4.36073C1.93738 4.27237 1.08005 4.33903 0.885186 4.9795C0.698147 5.59371 1.31421 6.1137 1.84936 6.43625C2.95516 7.10409 4.06771 7.77293 5.20127 8.39785C4.77406 9.76921 4.44662 11.1712 4.23517 12.5905C4.13663 13.2521 4.18547 14.1255 4.81035 14.3129C5.40922 14.4917 5.92999 13.8541 6.25603 13.302C6.92199 12.1763 7.58973 11.0441 8.21618 9.89167C9.05361 10.2535 9.90807 10.5755 10.7868 10.8329C11.7588 11.1176 13.3182 11.3512 13.9589 10.2662C14.7146 8.98905 13.1246 8.23246 12.2383 7.7109Z",
    fill: "#FD992A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroStar);
export default __webpack_public_path__ + "static/media/hero-star.c506e5480e0ec2841b22668bedfb3a64.svg";
export { ForwardRef as ReactComponent };